<template>
    <section class="jsk-block pt-0" id="curricula">
      <div class="container">
        <div class="row text-center mt-5">
          <div class="col-12 col-md-12">
            <h2>{{ $t("coursesPage.modulesTitle") }}</h2>
          </div>
        </div>

        <div class="row text-center align-items-center-lg pt-5">
          <!-- hello computer -->
          <div class="col-12 col-lg-6 col-md-6 col-sm-12">
             <router-link to="/hello-computer">
              <img src="./../assets/images/curricula/hello-computer.png" class="img-fluid w-75 px-5 py-5" alt="jskids modul avansati">
             </router-link>
            <p class="h4">{{ $t("coursesPage.moduleZeroTitle") }}</p>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleZeroAge") }}</span>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleZeroLevel") }}</span>
            <span class="badge badge-pill bg-black mr-2" v-html="moduleZeroPrice"></span>
            <p class="mt-3">
             {{ $t("coursesPage.moduleZeroText") }}
            </p>
            <router-link to="/hello-computer" class="bold-underlined">{{ $t("coursesPage.seeCurriculaBtn") }}</router-link>
          </div>

          <!-- hello world -->
          <div class="col-12 col-lg-6 col-md-6 col-sm-12">
            <router-link to="/hello-world">
              <img src="./../assets/images/curricula/hello-world.png" class="img-fluid w-75 px-5 py-5" alt="jskids modul incepatori">
            </router-link>
            <p class="h4">{{ $t("coursesPage.moduleOneTitle") }}</p>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleOneAge") }}</span>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleOneLevel") }}</span>
            <span class="badge badge-pill bg-black mr-2" v-html="moduleOnePrice"></span>
            <p class="mt-3">
              {{ $t("coursesPage.moduleOneText") }}
            </p>
           <router-link to="/hello-world" class="bold-underlined">{{ $t("coursesPage.seeCurriculaBtn") }}</router-link>
          </div>
        </div>

        <div class="row text-center align-items-center-lg pt-5">
          <!-- hello js -->
          <div class="col-12 col-lg-6 col-md-6 col-sm-12">
            <router-link to="/hello-javascript">
              <img src="./../assets/images/curricula/hello-javascript.png" class="img-fluid w-75 px-5 py-5" alt="jskids modul mediu">
            </router-link>
            <p class="h4">{{ $t("coursesPage.moduleTwoTitle") }}</p>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleTwoAge") }}</span>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleTwoLevel") }}</span>
            <span class="badge badge-pill bg-black mr-2" v-html="moduleTwoPrice"></span>
            <p class="mt-3">
             {{ $t("coursesPage.moduleTwoText") }}
            </p>
            <router-link to="/hello-javascript" class="bold-underlined">{{ $t("coursesPage.seeCurriculaBtn") }}</router-link>
          </div>

           <!-- ready go play -->
          <div class="col-12 col-lg-6 col-md-6 col-sm-12">
             <router-link to="/ready-go-play">
              <img src="./../assets/images/curricula/ready-go-play.png" class="img-fluid w-75 px-5 py-5" alt="jskids modul avansati">
             </router-link>
            <p class="h4">{{ $t("coursesPage.moduleThreeTitle") }}</p>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleThreeAge") }}</span>
            <span class="badge badge-pill bg-yellow mr-2">{{ $t("coursesPage.moduleThreeLevel") }}</span>
            <span class="badge badge-pill bg-black mr-2" v-html="moduleThreePrice"></span> 
            <p class="mt-3">
             {{ $t("coursesPage.moduleThreeText") }}
            </p>
            <router-link to="/ready-go-play" class="bold-underlined">{{ $t("coursesPage.seeCurriculaBtn") }}</router-link>
          </div>

          <!-- end -->
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: "modules",
  props: ["moduleZeroPrice", "moduleOnePrice", "moduleTwoPrice", "moduleThreePrice"]
};
</script>